import React from 'react'
import PropTypes from 'prop-types'
import FieldTitle from '../../../molecules/FieldTitle'
import { fieldTitle } from '../../../../configs/templatesConfig'
import FieldCheckboxTitle from '../../../molecules/FieldCheckboxTitle'

const name = 'is_trackable'

const IsTrackable = ({ config }) => {
  const { title, hint } = fieldTitle(name, config.is_trackable)
  return (
    <>
      {config.is_trackable === 'official_decide' ? (
        <FieldCheckboxTitle name={name} label={title} description={hint} />
      ) : (
        <FieldTitle title={title} hint={hint} />
      )}
    </>
  )
}

export default IsTrackable

IsTrackable.propTypes = {
  config: PropTypes.object
}
